import React, { VFC } from 'react';
import { Redirect, Switch } from 'react-router-dom';
import { Authenticator } from '../pages/Authenticator';
import { Login } from '../pages/Login';
import { ForgotPassword } from '../pages/ForgotPassword';
import { Route } from './Route';
import { ROUTER_PATHS } from '../constants';
import { Portal } from '../pages/Portal';
import { RecoveryPassword } from '~/pages/RecoveryPassword';
import { VerifyCode } from '~/pages/VerifyCode';
import { ViewLetter } from '~/pages/Portal/Admin/Groups/ViewLetter';

export const Routes: VFC = () => {
  return (
    <Switch>
      <Route path={ROUTER_PATHS.LOGIN} exact component={Login} />
      <Route
        path={ROUTER_PATHS.FORGOT_PASSWORD}
        exact
        component={ForgotPassword}
      />
      <Route
        path={ROUTER_PATHS.FORGOT_PASSWORD_TOKEN}
        exact
        component={RecoveryPassword}
      />
      <Route
        path={ROUTER_PATHS.EXPIRED_PASSWORD}
        exact
        component={RecoveryPassword}
      />
      <Route path={ROUTER_PATHS.VERIFY_CODE} exact component={VerifyCode} />

      <Route
        path={ROUTER_PATHS.AUTHENTICATOR}
        exact
        component={Authenticator}
      />
      <Route path={ROUTER_PATHS.PORTAL.HOME} component={Portal} isPrivate />
      <Route path={ROUTER_PATHS.VIEW_LETTER} component={ViewLetter} exact />
      <Redirect to={ROUTER_PATHS.LOGIN} />
    </Switch>
  );
};
